import { render, staticRenderFns } from "./PartnerNoticeForm.vue?vue&type=template&id=0a804759&"
import script from "./PartnerNoticeForm.vue?vue&type=script&lang=ts&"
export * from "./PartnerNoticeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports